import './app';
// Templates
import "./templates/blog";
import "./templates/collections";
import "./templates/password";
import "./templates/product";
// Components
import "./components/payment-delivery-icons";
import "./components/main-account";
import "./components/megamenu";
//Sections
import "./sections/announcement";
import "./sections/cart-drawer";
